export default __webpack_public_path__ + "static/media/ico-generic-db-score-high.cc42803a.svg";